var _style, _rect, _rect2, _rect3, _rect4, _path, _g, _path2, _g2, _path3, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivacypolicy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 352.83 199.93",
    style: {
      enableBackground: "new 0 0 352.83 199.93"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:none;}\n\t.st4{fill:url(#Shield_Shape_512dp_1_);stroke:url(#Shield_Shape_512dp_2_);stroke-miterlimit:10;}\n\t.st5{fill:#7A2C7D;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:url(#Shield_Shape_512dp-2_1_);stroke:url(#Shield_Shape_512dp-2_2_);stroke-miterlimit:10;}\n\t.st8{fill:url(#Shield_Shape_512dp-3_1_);stroke:url(#Shield_Shape_512dp-3_2_);stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.8479,
    y1: 37.647,
    x2: 176.4131,
    y2: 37.647,
    gradientTransform: "matrix(1 0 0 -1 0 199.9102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.025
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.225
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.626
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.898
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BA1A7"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 105.85,
    y: 159.32,
    className: "st0",
    width: 70.57,
    height: 5.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.1776,
    y1: 53.3282,
    x2: 278.3407,
    y2: 53.3282,
    gradientTransform: "matrix(1 0 0 -1 0 199.9102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.025
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.225
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.626
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.898
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BA1A7"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 237.18,
    y: 143.64,
    className: "st1",
    width: 41.16,
    height: 5.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3225,
    y1: 53.3282,
    x2: 74.4855,
    y2: 53.3282,
    gradientTransform: "matrix(1 0 0 -1 0 199.9102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.025
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.225
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.626
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    style: {
      stopColor: "#9BA1A7",
      stopOpacity: 0.898
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BA1A7"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.32,
    y: 143.64,
    className: "st2",
    width: 41.16,
    height: 5.88
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    width: 352.83,
    height: 199.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shield_Shape_512dp_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.529,
    y1: 93.3941,
    x2: 231.2972,
    y2: 93.3941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shield_Shape_512dp_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.029,
    y1: 93.4096,
    x2: 231.7972,
    y2: 93.4096
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82207F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4549C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shield_Shape_512dp",
    className: "st4",
    d: "M176.41,164.65c37.08-17.49,50.31-49.13,53.7-71.99 c0.69-5.13,1.08-10.29,1.18-15.46V38.47l-54.88-16.34l-54.88,16.34V77.2c0.1,5.17,0.5,10.33,1.18,15.46 C126.1,115.53,139.34,147.17,176.41,164.65z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PRIVACY_512dp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M148.21,110.44c0-7.58,13.11-13.74,28.2-14.02c15.09,0.28,28.2,6.44,28.2,14.02v0.79 c12.7-15.57,10.37-38.5-5.2-51.2s-38.5-10.37-51.2,5.2c-10.92,13.39-10.92,32.6,0,45.99L148.21,110.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M204.61,110.44c0-7.58-13.11-13.74-28.2-14.02c-15.09,0.28-28.2,6.44-28.2,14.02v0.79 c12.7,15.57,35.62,17.91,51.19,5.21c1.91-1.56,3.65-3.3,5.21-5.21L204.61,110.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M161.86,75.2c0-8.04,6.52-14.56,14.56-14.56c8.04,0,14.56,6.52,14.56,14.56s-6.52,14.56-14.56,14.56 C168.38,89.75,161.86,83.24,161.86,75.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shield_Shape_512dp-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.2029,
    y1: 103.162,
    x2: 109.7682,
    y2: 103.162
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shield_Shape_512dp-2_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.7029,
    y1: 103.1775,
    x2: 110.2682,
    y2: 103.1775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82207F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4549C"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shield_Shape_512dp-2",
    className: "st7",
    d: "M74.49,148.97c23.84-11.24,32.34-31.58,34.52-46.28c0.44-3.3,0.7-6.61,0.76-9.94 V67.86l-35.28-10.5L39.2,67.86v24.89c0.07,3.32,0.32,6.64,0.76,9.94C42.14,117.39,50.65,137.73,74.49,148.97z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SECURITY_512dp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.35,92.57h-2.14v-4.79c0-5.92-4.8-10.72-10.72-10.73c-5.92,0-10.72,4.8-10.73,10.72c0,0,0,0.01,0,0.01 v4.79h-2.14c-2.26,0.01-4.09,1.84-4.09,4.1v22.27c0,2.26,1.83,4.09,4.09,4.1h25.73c2.26-0.01,4.09-1.84,4.09-4.1V96.67 C91.44,94.41,89.61,92.58,87.35,92.57z M67.86,87.79c0-3.66,2.97-6.63,6.63-6.63c3.66,0,6.63,2.97,6.63,6.63v4.79H67.86V87.79z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M78.97,106.09c0-2.48-2.01-4.48-4.48-4.48c-2.48,0-4.48,2.01-4.48,4.48c0,1.72,0.99,3.29,2.53,4.04v4.54 h3.9v-4.54C77.98,109.38,78.97,107.81,78.97,106.09z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shield_Shape_512dp-3_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.0581,
    y1: 103.162,
    x2: 313.6233,
    y2: 103.162
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shield_Shape_512dp-3_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.5581,
    y1: 103.1775,
    x2: 314.1233,
    y2: 103.1775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82207F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4549C"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shield_Shape_512dp-3",
    className: "st8",
    d: "M278.34,148.97c23.84-11.24,32.34-31.58,34.52-46.28 c0.44-3.3,0.7-6.61,0.76-9.94V67.86l-35.28-10.5l-35.28,10.5v24.89c0.07,3.32,0.32,6.64,0.76,9.94 C246,117.39,254.51,137.73,278.34,148.97z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "CONTROL_512dp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M262.94,87.57c-0.01-3.43,2.76-6.23,6.19-6.24c0.03,0,0.07,0,0.1,0h17.98c3.44-0.04,6.27,2.71,6.32,6.16 c0.04,3.44-2.71,6.27-6.16,6.32c-0.05,0-0.1,0-0.16,0h-17.98c-3.43,0.04-6.25-2.7-6.29-6.13 C262.94,87.64,262.94,87.6,262.94,87.57z M293.74,113.88c0.01-3.43-2.76-6.23-6.19-6.24c-0.03,0-0.07,0-0.1,0h-17.98 c-3.44-0.04-6.27,2.71-6.32,6.16s2.71,6.27,6.16,6.32c0.05,0,0.1,0,0.16,0h17.98c3.43,0.04,6.25-2.7,6.29-6.13 C293.74,113.95,293.74,113.92,293.74,113.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M296.28,87.37c0,4.95-4.02,8.96-8.97,8.96c-4.95,0-8.96-4.02-8.96-8.97c0-4.95,4.01-8.96,8.96-8.96 C292.26,78.4,296.27,82.42,296.28,87.37C296.28,87.37,296.28,87.37,296.28,87.37z M269.37,104.72c-4.95,0-8.97,4.01-8.97,8.97 c0,4.95,4.01,8.97,8.97,8.97c4.95,0,8.97-4.01,8.97-8.96c0.02-4.93-3.97-8.95-8.9-8.97 C269.42,104.72,269.39,104.72,269.37,104.72L269.37,104.72z"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacypolicy);
export default __webpack_public_path__ + "static/media/privacypolicy.0b0970fc9aad95b4d460e492494e0f90.svg";
export { ForwardRef as ReactComponent };